export default __webpack_public_path__ + "static/media/12-IMusica-Black.643b9680.png";